import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-spinner',
  template: `
    <div class="spinner-wrapper">
      <mat-spinner [diameter]="size" [color]="color"></mat-spinner>
    </div>
  `,
  styles: [
    `
      .spinner-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
      }
    `,
  ],
})
export class ProgressSpinnerComponent implements OnInit {
  @Input() size = 50;
  @Input() color: string = 'primary';

  constructor() {}

  ngOnInit(): void {}
}
